<template>
	<div>
		<v-card-title>Kollaboration Erzeugen</v-card-title>
		<v-card-text>
			<p>Mit diesem Menu erstellen sie einen neuen Kollaborationsvorgang. </p>
			<v-form ref="form">
				<v-text-field label="Name des Vorgangs" v-model="name"></v-text-field>
				<v-btn-toggle style="width: 100%" color="primary" v-model="type">
					<v-btn style="width: 50%" value="poll">Quick-Poll</v-btn>
					<v-btn style="width: 50%" value="delegation">Delegation</v-btn>
				</v-btn-toggle>
				<v-text-field label="Nachricht an Ihre Mitarbeiter" v-model="message"></v-text-field>
				<v-select label="Mitarbeiterauswahl" chips multiple v-model="members" :items="users" item-value="id" item-text="display_name"></v-select>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn rounded text color="red" @click="$emit('close')">Abbrechen</v-btn>
			<v-btn rounded color="primary" @click="add">Bestätigen</v-btn>
		</v-card-actions>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "NewCollaboration", 
		props: {
			setType: {}	
		},
		data: () => {
			return {
				name: '', 
				message: '',
				type: 'poll',
				respondents: [],
				members: []
			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				settings: state => state.assessmentSettings,
				users: state => state.users
			})
		},
		methods: {
			add(){
				var collab = {
					id: this.generateId(), 
					name: this.name,
					type: this.type, 
					status: "not_started",
					assessment: "HhoSAanfneFrKeASrw8",
					message: this.message, 
					members: this.members,
					completion_rate: 0,
					pinned: 		false, 
					response_count:	0,
					started_count:	0,
					responses: 		[],
				}
				this.$store.dispatch("collaborations/add", collab).then(() => {
					this.$refs.form.reset();
					this.$emit("close")
				})
			}
		},
		watch: {
			settings: {
				deep: true,
				immediate: true,
				handler(newValue, oldValue ){
					if( newValue && !oldValue ){
						if( this.$store.hasModule("assessmentSettings")  ){
							this.$store.dispatch("assessmentSettings/getSettings").then( ( ) => {
							})
						}
						if( this.$store.hasModule("surveys")  ){
							this.$store.dispatch("surveys/getAll").then( ( ) => {
							})
						}
					}
					
				}
			}
		},
		created(){
			if( this.setType ){
				this.type = this.setType }
		}

	}
</script>